import { motion } from "framer-motion";
import { ArrowRight, Star } from "lucide-react";
import { IMAGES } from "../../lib/content";

export const Hero = () => {
  return (
    <section id="home" data-testid="hero-section" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img src={IMAGES.hero} alt="Luxury managed property" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A110D] via-[#0A110D]/85 to-[#0A110D]/40" />
        <div className="absolute inset-0 bg-grain opacity-[0.07] pointer-events-none" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 w-full pt-28 pb-20">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="flex items-center gap-2 mb-7"
        >
          <Star size={14} className="text-[#D4AF37] fill-[#D4AF37]" />
          <span className="overline">Managed with morals & high standards</span>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.1, ease: "easeOut" }}
          className="font-serif-display text-[#FDFBF7] text-4xl sm:text-6xl lg:text-7xl leading-[1.05] tracking-tight max-w-4xl"
        >
          Where great properties are <span className="text-[#D4AF37] italic">faithfully</span> stewarded.
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.25, ease: "easeOut" }}
          className="mt-8 text-[#A3B1A8] text-base md:text-lg max-w-xl leading-relaxed"
        >
          North Emerald Holdings acquires, improves, and manages residential properties, bringing lasting
          value to the neighborhoods and communities we serve, with integrity and responsible growth.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.4, ease: "easeOut" }}
          className="mt-11 flex flex-col sm:flex-row gap-4"
        >
          <a
            href="#services"
            data-testid="hero-secondary-cta"
            className="group inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-[#D4AF37] text-[#0A110D] font-semibold hover:bg-[#F0C742] transition-colors duration-300"
          >
            Explore Services
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform duration-300" />
          </a>
        </motion.div>
      </div>
    </section>
  );
};
